"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchEvent = void 0;

const dispatchEvent = event => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
  return event;
};

exports.dispatchEvent = dispatchEvent;